


































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'documents', 'meta', 'costs'
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      name: { required },
      color: { required },
      archived_at: {  },
      starter_type_id: {  },
    }

    return {
      form: rules
    }
  }
})
export default class TransportCostsForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Array }) deliveryInstances!: any[];
  @Prop({ type: Object }) initParams!: any;
  @Prop({ type: String }) delivery_zone_group_id!: any;
  @Prop({ type: String }) delivery_date!: any;
  @Prop({ type: String }) by_mode!: any;


  meta!: any;

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }
  get purposes(){
    let _ignore = ['delivery_tk'];
    if (this.by_mode == 'movement') {
      _ignore = [
        ..._ignore,
        'delivery_nsk_city',
        'warehouse',
        'delivery',
        'storage',
        'movement',
      ]
    } else {
      _ignore = [
        ..._ignore,
        'return',
        'pick_up',
        'movement',
        'yandex'
      ]
    }
    return this.meta.purpose.controlItems.filter((item: any) => {
      return !_ignore.includes(item.id)
    })
  }

  public mounted() {
    this.$store.dispatch(`${STORE_KEY}/loadDeliveryInstanes`, {
      ids: this.deliveryInstances
    });
    this.$store.dispatch(`${STORE_KEY}/setDeliveryDate`, {
      delivery_date: this.delivery_date
    });
  }

  changeValue(idx: number, field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      idx, field, newValue: value
    });
  }

  setTransportCostValue(purpose: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/setTransportCostValue`, {
      purpose, 
      newValue: value, 
      delivery_zone_group_id: this.delivery_zone_group_id
    });
  }

  saveFormData() {
    this.$store.dispatch(`${STORE_KEY}/saveForm`)
    .then((result) => {
      this.$buefy.snackbar.open(`Данные успешно сохранены`);

      this.$emit('form-close');
      (this.$parent as any).close();
    })
    .catch((e: any) => {
      console.log(e)
      this.$buefy.snackbar.open({
        type: 'is-warning',
        message: `При сохранении возникли проблемы. Попробуйте позже.`
      })
    })
  }
  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

